import { observable, makeObservable, action } from "mobx";
import { api } from "../../constants/apis";
import { post } from "../../utils/axios-requests";

export default class LoginUiStore {
  @observable error: string = '';

  constructor() {
    makeObservable(this);
  }

  @action
  public setError = (err: string) => {
    this.error = err;
  };

  @action
  public submitData = async (values: any) => {
    try {
      const res = await post(
        api.users.login,
        {},
        {},
        {
          username: values.email,
          password: values.password,
        }
      );

      if (res.status !== 200) {
        return null;
      }

      return res.data;
    } catch (error: any) {
      if (error.response) {
        this.setError(error.response.data);
      } else {
        this.setError(
          "Error: Can't complete this process right now. Please try again later"
        );
      }

      return false;
    }
  };

  @action
  public confirmEmail = async (email: string, code: string) => {
    try {
      const res = await post(
        api.users.confirmEmail,
        {},
        {
          email,
          code
        }
      );

      if (res.status !== 200) {
        return false;
      }

      return true;
    } catch (error: any) {
      if (error.response) {
        this.setError(error.response.data);
      } else {
        this.setError(
          "Error: Can't complete this process right now. Please try again later"
        );
      }

      return false;
    }
  };


}
